import * as React from 'react';
import { CssBaseline, Container, Box } from '@mui/material';
import { Outlet } from 'react-router-dom';

import Header from './Header';
import Footer from './Footer';

function MasterPage() {

  

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', minHeight: '100vh' }}>
      <CssBaseline />

      {/* Header */}
      <Header />

      {/* Contenido Principal */}
      <Container component="main" sx={{ flex: 1, mt: 4 }}>
        <Outlet />
      </Container>

      {/* Pie de Página */}
      <Footer alignItems="center" />
    </Box>
  );
}

export default MasterPage;
